import { calculateComponentStatus } from './component-status';

export const ComponentSearchMap = {
    0: (component) => [
        component.id?.toString(),
        component.name,
        component.description,
        ...(component.subcomponents?.flatMap((sub) => [
            sub.subcomponentId?.toString(),
            sub.subcomponentName,
        ]) || []),
    ],
    all: (component) => [
        component.id?.toString(),
        component.name,
        component.description,
        ...(component.subcomponents?.flatMap((sub) => [
            sub.subcomponentId?.toString(),
            sub.subcomponentName,
        ]) || []),
    ],
    id: (component) => component.id?.toString(),
    name: (component) => component.name,
    description: (component) => component.description,
    'criteria id': (component) =>
        component.subcomponents?.map((sub) => sub.subcomponentId?.toString()) || [],
    'criteria name': (component) =>
        component.subcomponents?.map((sub) => sub.subcomponentName) || [],
};

export const ComponentSortMap = {
    id: (component) => component.id,
    name: (component) => component.name,
    description: (component) => component.description,
};

export const ComponentFilterMap = {
    componentStatusIds: (component, filterValue) => {
        if (!Array.isArray(filterValue) || filterValue.length === 0) {
            return true;
        }

        const componentStatus = calculateComponentStatus(component.subcomponents || []);
        return filterValue.includes(componentStatus);
    },
};

export const filterSubcomponentsByStatusAndRating = (subcomponents, statusId, ratingId) => {
    if (!Array.isArray(subcomponents)) {
        return [];
    }

    if (
        (!Array.isArray(statusId) || statusId.length === 0) &&
        (!Array.isArray(ratingId) || ratingId.length === 0)
    ) {
        return subcomponents;
    }

    return subcomponents.filter((subcomponent) => {
        const matchesStatus =
            !Array.isArray(statusId) ||
            statusId.length === 0 ||
            statusId.includes(subcomponent.statusId);
        const matchesRating =
            !Array.isArray(ratingId) ||
            ratingId.length === 0 ||
            ratingId.includes(subcomponent.ratingId);
        return matchesStatus && matchesRating;
    });
};

export const filterSubcomponentsByStatus = (subcomponents, statusId) => {
    if (!Array.isArray(subcomponents)) {
        return [];
    }

    if (!Array.isArray(statusId) || statusId.length === 0) {
        return subcomponents;
    }

    return subcomponents.filter((subcomponent) => statusId.includes(subcomponent.statusId));
};

export const filterSubcomponentsByRating = (subcomponents, ratingId) => {
    if (!Array.isArray(subcomponents)) {
        return [];
    }

    if (!Array.isArray(ratingId) || ratingId.length === 0) {
        return subcomponents;
    }

    return subcomponents.filter((subcomponent) => ratingId.includes(subcomponent.ratingId));
};

export const filterSubcomponentsByOwner = (subcomponents, ownerIds) => {
    if (!Array.isArray(subcomponents)) {
        return [];
    }

    if (!Array.isArray(ownerIds) || ownerIds.length === 0) {
        return subcomponents;
    }

    return subcomponents.filter((subcomponent) => {
        if (!subcomponent.owners) {
            return false;
        }

        return ownerIds.some((selectedOwner) => {
            const ownersValue = subcomponent.owners.toLowerCase();
            const selectedValue = selectedOwner.toLowerCase();
            return ownersValue.includes(selectedValue);
        });
    });
};

export const filterSubcomponentsByFrequency = (subcomponents, frequencyIds) => {
    if (!Array.isArray(subcomponents)) {
        return [];
    }

    if (!Array.isArray(frequencyIds) || frequencyIds.length === 0) {
        return subcomponents;
    }

    return subcomponents.filter((subcomponent) => {
        if (!subcomponent.frequency) {
            return false;
        }

        return frequencyIds.includes(subcomponent.frequency);
    });
};
